/**
 * The record screen's own route path: `./routes.ts` registers it. Kept here, not in
 * `../paths.ts`, so no other screen edits this file's own path.
 *
 * Creation has no path of its own: `NewCampaignDialog` opens over whatever route triggered it.
 *
 * Relative to the router's `basepath`, like every other route literal in this plane.
 */

import { interpolatePath } from '@tanstack/react-router';

export const RECORD_PATH = '/c/$campaignId/record';

export function recordPath(campaignId: string): string {
  return interpolatePath({ path: RECORD_PATH, params: { campaignId } }).interpolatedPath;
}
